module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-square-fill-9f3447ff.svg";